import { ApolloClient } from "@apollo/client";
import {
  ICheckCreditMemoDocumentNumberParams,
  ICheckCreditMemoDocumentNumberRepository,
  ICheckCreditMemoDocumentNumberResponse,
} from "@/core/repositories/accounting";
import CHECK_CREDIT_MEMO_DOCUMENT_NUMBER from "@/core/graphql/accounting/checkCreditMemoDocumentNumber";

interface ICheckCreditMemoDocumentNumberQueryResponse {
  checkCreditMemoDocumentNumber: ICheckCreditMemoDocumentNumberResponse;
}

export class CreditMemoDocumentNumberRepository implements ICheckCreditMemoDocumentNumberRepository {
  constructor(private readonly client: ApolloClient) {}

  public async checkCreditMemoDocumentNumber(
    params: ICheckCreditMemoDocumentNumberParams
  ): Promise<ICheckCreditMemoDocumentNumberResponse> {
    const { data } = await this.client.query<ICheckCreditMemoDocumentNumberQueryResponse>({
      query: CHECK_CREDIT_MEMO_DOCUMENT_NUMBER,
      variables: {
        params: {
          document_number: params.documentNumber,
        },
      },
      fetchPolicy: "network-only",
    });

    if (!data?.checkCreditMemoDocumentNumber) {
      throw new Error("Failed to check credit memo document number");
    }

    return data.checkCreditMemoDocumentNumber;
  }
}
